import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { throttle } from 'throttle-debounce';
import { getGoodsList as getGoodsListService } from '../../../service/articles';
import GoodsUI from '../../../component/GoodsUI';
import { gtag } from '../../../util-lib/statistics';
import './index.scss';

function getArticleId() {
  return parseInt(window.__PAGE_DATA.articleId, 10);
}

class GoodsList extends React.Component {
  static propTypes = {
    articleId: PropTypes.number
  }

  static defaultProps = {
    articleId: getArticleId()
  }

  constructor() {
    super();
    this.slideDom = React.createRef();
    this.state = {
      goodsList: [],
      page: 1,
      status: 'INIT',
      showSlide: false
    };
  }

  componentDidMount() {
    const { page } = this.state;
    this.fetchGoodsList(page);

    this.slideDom.current.addEventListener('scroll', throttle(300, () => {
      this.goodsListScroll();
    }));
  }

  fetchGoodsList(page, pageSize = 20) {
    this.setState({
      status: 'PENDING'
    });
    const { articleId } = this.props;
    getGoodsListService({
      articleId,
      page,
      pageSize
    }).then((res) => {
      const { goodsList } = this.state;
      this.setState({
        goodsList: goodsList.concat(res),
        page
      });
      this.setState({
        status: res.length > 0 ? 'SUCCESS' : 'FINISH'
      });
    }).catch((err) => {
      this.setState({
        status: 'FAILURE'
      });
      // eslint-disable-next-line
      console.error('获取商品列表接口', err);
    });
  }

  goodsListScroll() {
    const { status } = this.state;
    if (status === 'FINISH' || status === 'PENDING') return;
    const slideDom = this.slideDom.current;
    const scrollTop = slideDom.scrollTop;
    const scrollHeight = slideDom.scrollHeight;
    const slideDomHeight = slideDom.clientHeight;
    const { page } = this.state;
    if (scrollTop + slideDomHeight >= scrollHeight - 500) {
      const HandlePage = page + 1;
      this.fetchGoodsList(HandlePage);
    }
  }

  handleSlide() {
    const { showSlide } = this.state;
    gtag.event('articles_goodslist_click');
    if (showSlide) {
      this.setState({ showSlide: false });
    } else {
      this.setState({ showSlide: true });
      // document.body.className = 'zzc_hidden';
      gtag.event('articles_goodslist_click');
    }
  }

  handleGoodsClick(item) {
    gtag.event('articles_goods_click', {
      content_type: 'product',
      items: [{
        id: item.id,
        name: item.name
      }]
    });
  }

  render() {
    const { goodsList, showSlide } = this.state;
    return (
      <React.Fragment>
        {goodsList.length > 0
          && (
          <div className="recBtn" onClick={() => this.handleSlide()}>
            <div className="maskBtn" />
            <div className="recIcon" />
            <span>推荐商品</span>
          </div>
          )
        }

        <div className="slideContainer">
          <div
            className={classnames({
              goodsListMask: true,
              show: showSlide
            })}
            onClick={() => this.handleSlide()}
          />
          <div
            className={classnames({
              slide: true,
              show: showSlide
            })}
          >
            <div className="listScroll" ref={this.slideDom}>
              {
                goodsList.map((goods, index) => {
                  const key = `${goods.id}-${index}`;
                  return (
                    <GoodsUI
                      key={key}
                      layout="1-1"
                      scale="4x3"
                      data={goods}
                      onClick={this.handleGoodsClick}
                    />
                  );
                })
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}


function createApiContainer() {
  const node = document.createElement('div');
  node.className = 'component-api-container';
  document.body.appendChild(node);
  return node;
}
ReactDOM.render(<GoodsList />, createApiContainer());
export default GoodsList;
